<div [innerHtml]="(expanded || !toggleButton) ? (input | unsafeHtml) : (input | ellipsis: limit)"></div>
@if (toggleButton) {
  <button
    htm-button
    theme="plain"
    (click)="toggle()">
    {{ expanded ? ('button.show_less' | translate) : ('button.read_more' | translate) }}
  </button>
}
